import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    ColorFill: {
        fill: '#fff'
    }
});

const ResetIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);

    return (
        <>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 37.8 37.8"
                style={{
                    width: '32px'
                }}
            >
                <path
                    className={classesInline.ColorFill}
                    d="M18.9,0C8.5,0,0,8.5,0,18.9c0,10.4,8.5,18.9,18.9,18.9c10.4,0,18.9-8.5,18.9-18.9C37.8,8.5,29.3,0,18.9,0z
	 M18.8,30.1c-2.5,0.1-5.1-0.7-7.2-2.4c-1.2-1-2.2-2.1-2.9-3.4C6.4,20,7,14.6,10.5,11L8.4,8.9c-0.1-0.1,0-0.3,0.1-0.4l7.6-1.2
	c0.1,0,0.2,0.1,0.2,0.2l-1.2,7.6c0,0.2-0.2,0.3-0.4,0.1l-2.1-2.1c-2.3,2.4-2.9,5.8-1.7,8.7c0.4,1.1,1.1,2.1,2.1,3
	c1.7,1.5,4,2.2,6.2,2L18.8,30.1z M29.4,28.9c0.1,0.1,0,0.3-0.1,0.4l-7.6,1.2c-0.1,0-0.2-0.1-0.2-0.2l1.2-7.6c0-0.2,0.2-0.3,0.4-0.1
	l2.1,2.1c2.3-2.4,2.9-5.8,1.7-8.7c-0.4-1.1-1.1-2.1-2.1-3c-1.7-1.5-4-2.2-6.2-2L19,7.7c2.5-0.1,5.1,0.7,7.2,2.4
	c1.2,1,2.2,2.1,2.9,3.4c2.3,4.2,1.7,9.6-1.8,13.2L29.4,28.9z"
                />
            </svg>
        </>
    );
};

export default ResetIcon;
